module.exports = __webpack_public_path__ + "static/media/Icn-z.98089db8.svg";